import { useNavigate } from 'react-router-dom'

import { Box, Button, Tabs, Tag, Title } from '@factorialco/deprecated-design-system'
import { SpendingPolicyFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import PolicyContainer from './PolicyContainer'

type Props = {
  canCreatePolicies: boolean
  spendingPolicies: SpendingPolicyFragment[]
}

const Overview = ({ canCreatePolicies, spendingPolicies }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  return (
    <Box gap="s32">
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Title
          variant="500"
          title={i18n.t('spending_policies.list.title')}
          description={i18n.t('spending_policies.list.description')}
        />
        {canCreatePolicies && (
          <Button.Router
            iconName="add"
            to={navigation.expenses.spendingPolicies.list.new.fullPath()}
          >
            {i18n.t('spending_policies.list.add_policy')}
          </Button.Router>
        )}
      </Box>
      <Tabs currentId="overview" onTabClicked={() => {}}>
        <Tabs.Tab id="overview" label={i18n.t('spending_policies.list.overview')}>
          <Box paddingY="s24" gap="s24">
            {spendingPolicies.map((policy) => {
              return (
                <PolicyContainer
                  key={policy.id}
                  spendingPolicy={policy}
                  defaultToggle={spendingPolicies.length === 1}
                  editable={canCreatePolicies}
                />
              )
            })}
            {canCreatePolicies && (
              <Box
                background="grey100"
                borderRadius={{ all: 'abs008' }}
                border={{
                  all: {
                    style: 'dashed',
                    width: 's2',
                    color: 'grey400',
                  },
                }}
                paddingX="s24"
                paddingY="s12"
                onClick={() => navigate(navigation.expenses.spendingPolicies.list.new.fullPath())}
                justifyContent="center"
                flexDirection="row"
              >
                <Tag type="transparent" icon="add" leftItem="icon">
                  {i18n.t('spending_policies.list.add_policy')}
                </Tag>
              </Box>
            )}
          </Box>
        </Tabs.Tab>
      </Tabs>
    </Box>
  )
}

export default Overview
